module.exports = __webpack_public_path__ + "static/media/applicant-terms-life-of-the-party.e566c8be.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/applicant-terms-life-of-the-party.pdf
// module id = 1512
// module chunks = 0